export default {
  methods: {
    formatUrl(videoStream) {
      // mediaAmp must be preloaded because of the way videojs load video urls
      switch (videoStream.type) {
        case 'youtube':
          return `https://www.youtube.com/watch?v=${videoStream.url}`;
        case 'http':
        case 'mp4':
          return videoStream.url;
        case 'm3u8':
          return videoStream.url;
        case 'vimeo':
          return videoStream.url;
        default:
          return videoStream.url;
      }
    },
    formatType(videoStream) {
      switch (videoStream.type) {
        case 'mediaamp':
          // until mediaAmp is loaded, use the low quality mp4 version
          if (videoStream.mediaAmpLoaded) return 'application/x-mpegURL';
          return 'video/mp4';
        case 'm3u8':
          return 'application/x-mpegURL';
        case 'youtube':
          return 'video/youtube';
        case 'dash':
          return 'application/dash+xml';
        case 'audio':
          return 'audio/mp3'
        case 'panopto':
          return 'video/panopto';
        case 'vimeo':
          return 'video/vimeo';
        case 'proquest':
          return 'video/proquest';
        case 'webm':
          return 'video/webm';
        default:
          return 'video/mp4';
      }
    },
  }

}
